// extracted by mini-css-extract-plugin
module.exports = {"ul":"TagsGray_ul__1wDOA","skin_colorBox":"TagsGray_skin_colorBox__lw9Nm","tag_linkbox":"TagsGray_tag_linkbox__2TKpJ","industry_linkbox":"TagsGray_industry_linkbox__7kwQr"};